<template>
	<modal ref="modal">
		<template #title>
			<span v-if="attendee!=null">{{ `Follow Up: ${attendee.first_name} ${attendee.last_name}` }}</span>
		</template>
		<template #body>
			<div v-if="attendee!=null">
				<label for="status" class="form-label">Event</label>
				<p class="mb-2 border p-4 py-2 px-3">{{ attendee.event_title }}</p>
				<label for="status" class="form-label">Name</label>
				<p class="mb-2 border p-4 py-2 px-3">{{ attendee.first_name }} {{attendee.last_name}}</p>
				<label for="status" class="form-label">Email</label>
				<p class="mb-2 border p-4 py-2 px-3">{{ attendee.email_address }}</p>
				<label for="status" class="form-label">Contact#</label>
				<p class="mb-2 border p-4 py-2 px-3">
					<span v-if="attendee.country_calling_code!==null" class="badge bg-info">{{attendee.contact_country}} +{{attendee.country_calling_code}}</span>
					{{ attendee.contactno }}
				</p>
				<label for="status" class="form-label">Status</label>
				<p class="mb-2 border p-4 py-2 px-3">{{ attendee.status }}</p>
				<div class="mb-4">
					<label for="status" class="form-label">Enter Follow-up Status</label>
					<select
						v-model="form.status"
						class="form-select"
						:class="{ 'is-invalid': form.errors.status }"
						id="status"
					>
						<option selected value="" disabled>Enter Follow-up Status</option>
                        <option value="will not join">Will not join (Email)</option>
                        <option value="will join next time">Will join next time (Email and SMS)</option>
                        <option value="call not answered">Call not answered (Email and SMS)</option>
                        <option value="number incorrect">Number Incorrect (Email)</option>
                        <option value="international number">International Number (Email)</option>
                        <option value="requested for callback">Requested for callback (Email and SMS)</option>
                        <option v-if="attendee.is_member==1" value="joined">Joined (Email and SMS)</option>
					</select>
					<div v-if="form.errors.status" class="invalid-feedback">
						{{ form.errors.status }}
					</div>
				</div>
				<div class="mb-4">
					<label
						for="remarks"
						class="form-label"
						:class="{ 'is-invalid': form.errors.remarks }"
						>Follow-up Remarks</label
					>
					<textarea
						v-model="form.remarks"
						class="form-control"
						row="5"
					></textarea>
					<div v-if="form.errors.remarks" class="invalid-feedback">
						{{ form.errors.remarks }}
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="followUp"
				type="button"
				class="btn btn-alt-primary"
				:disabled="form.processing"
			>
				<span v-if="!form.processing"><i class="fa fa-arrow-circle-up me-1"></i>Follow Up</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark me-1" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary" :disabled="form.processing">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref, toRef, toRefs, watch } from 'vue'

export default {
	props: {

	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			tkt_attendee_list_uuid 	: null,
			email_address 			: null,
			first_name 				: null,
			contactno 				: null,
			country_calling_code 	: null,
			status 					: null,
			remarks 				: null,
		})

		const attendee = ref(null);

		const setFollowupContent = (data)=>{ 
			attendee.value 					= data;
			form.tkt_attendee_list_uuid 	= data.tkt_attendee_list_uuid;
			form.email_address 				= data.email_address;
			form.first_name 				= data.first_name;
			form.contactno 					= data.contactno;
			form.country_calling_code 		= data.country_calling_code;
		}

		const followUp = () => {
			form.post(route('admin.post.tkt-attendee-followup'), {
				preserveState: true,
				preserveScroll: true,
				only:['total_claim','claim_by_data','checkins','filter','search','api_response'],
				onSuccess: () => {
					form.reset('status', 'remarks');
					toggleModal();
				},
			})
		}

		return {
			modal,
			form,
			setFollowupContent,
			attendee,
			followUp,
			toggleModal,
		}
	},
}
</script>
